import './src/main.css'
import Decoration7 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration7.name, Decoration7)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration7/index.js